import { ensureGroupSiteCreation } from './ensureGroupSiteCreation';
import getRecentFiles from './getRecentFiles';
import { startSharePointResourceTokenFetch } from './startSharePointResourceTokenFetch';
import {
    setSharePointItemsViewNavigationTargetPath,
    StartFilesHubListLoadDatapoint,
} from 'owa-group-files-hub-store';
import { getCurrentGroupSmtpAddress, getGroupResourceUrl } from 'owa-groups-shared-store';

// perform all the actions that we want to do when user navigates to files hub
// Make sure to have everything in this file as async. We don't want to have any performance impact on loading files view due to any function being called here.
// This method should be used to start any asynchronous calls/processing we want to do when user navigates to files.
export async function onFilesNavigation() {
    const smtpAddress = getCurrentGroupSmtpAddress();
    const groupWebAbsoluteUrl = getGroupResourceUrl(smtpAddress, 'Site');

    // Navigate to root when coming back into the files hub for this group
    setSharePointItemsViewNavigationTargetPath(smtpAddress, '');

    StartFilesHubListLoadDatapoint(smtpAddress);
    getRecentFiles(smtpAddress);

    // async function to start the prefetch of access Token and update the store with the status
    if (groupWebAbsoluteUrl) {
        startSharePointResourceTokenFetch(groupWebAbsoluteUrl)
            .then(() => {
                ensureGroupSiteCreation(smtpAddress)
                    .then(() => {
                        // When polling is done group site url may change from www.sharepoint.com to www.sharepoint-df.com
                        // We need fetch token for the provisioned url
                        if (
                            getCurrentGroupSmtpAddress().toLowerCase() == smtpAddress.toLowerCase()
                        ) {
                            startSharePointResourceTokenFetch(
                                getGroupResourceUrl(smtpAddress, 'Site')
                            ).catch(() => {
                                // startSharePointResourceTokenFetch will only throw rejection when token fetch is already started by some other process.
                                // so if it's already started we just catch the rejection and do nothing as we don't want to throw the rejection on window
                            });
                        }
                    })
                    .catch(() => {
                        // do nothing if polling failed
                    });
            })
            .catch(() => {
                // startSharePointResourceTokenFetch will only throw rejection when token fetch is already started by some other process or there is a permanent exception while trying to get the token.
                // so if it's already started or the error is permanent we just catch the rejection and do nothing as we don't want to throw the rejection on window
            });
    }
}
